import type { SelectOption } from "components/v2/Select/types";

export type ScacCode = { number: string; name: string };

export const SCAC_OTHER_VALUE = "__other__";

export function buildScacSelectOptions(scacCodes: ScacCode[], includeOther = false): SelectOption[] {
  const options = scacCodes.map(({ number, name }) => ({
    label: number,
    value: number,
    supportingText: name,
  }));

  if (includeOther) {
    options.push({ label: "Other", value: SCAC_OTHER_VALUE });
  }

  return options;
}

export function isValidScacCode(code: string): boolean {
  return /^[A-Z]{4}$/.test(code);
}

export function extractContainerPrefix(reference: string): string | null {
  const trimmed = reference.trim().toUpperCase();
  if (trimmed.length < 4) return null;

  const prefix = trimmed.slice(0, 4);
  if (!isValidScacCode(prefix)) return null;

  return prefix;
}

export function findScacNumberInList(prefix: string, scacCodes: ScacCode[]): string | null {
  const match = scacCodes.find((code) => code.number.toLowerCase() === prefix.toLowerCase());
  return match?.number ?? null;
}

export function resolveScacName(scacNumber: string | null, scacCodes: ScacCode[]): string | undefined {
  if (!scacNumber || scacNumber === SCAC_OTHER_VALUE) return undefined;

  return scacCodes.find((code) => code.number.toLowerCase() === scacNumber.toLowerCase())?.name;
}

export function resolveScacNumberFromStoredName(storedName: string, scacCodes: ScacCode[]): string | null {
  return scacCodes.find((code) => code.name === storedName)?.number ?? null;
}

export function resolveAutoContainerScacNumber(reference: string, scacCodes: ScacCode[]): string | null {
  const prefix = extractContainerPrefix(reference);
  if (!prefix) return null;

  return findScacNumberInList(prefix, scacCodes);
}
